export const showModalFile = (state) => state.showModal;

export const documentType = (state) => state.documentType
  .sort(({ label: a }, { label: b }) => a.localeCompare(b));

export const entity = (state) => state.entity
  .sort(({ label: a }, { label: b }) => a.localeCompare(b));

export const loading = (state) => state.loading;
